export default __webpack_public_path__ + "static/media/SZ09.5b4cb9ba.mp3";